import { useMemo } from "react";

import { FeatureIslandCategoryQuestionForMain } from "@/components/features/_layouts/island/main-with-category/components/category-main-question";

import { InputNumberField } from "@/components/ui/form/fields/input-field/input-number";

import { useOptionMinimumBuyableNumPerTarget } from "./hooks";

export const QuestionOptionMinimumBuyableNumPerTarget = () => {
	const {
		isEdited,
		hasError,

		minimumBuyableNumPerTarget,
		onSetMinimumBuyableNumPerTarget,
	} = useOptionMinimumBuyableNumPerTarget();

	const title = useMemo(() => "購入可能な下限数", []);

	const guide = useMemo(
		() => `ゲストが一度の予約でいくつから購入することができるかを設定しましょう。<br />
	日毎に選択可能なサービスの場合は、日毎に購入可能な下限になります。`,
		[],
	);

	return (
		<FeatureIslandCategoryQuestionForMain
			required={false}
			title={title}
			guide={guide}
			isEdited={isEdited}
			hasError={hasError}
			inputChildren={
				<div className="flex flex-wrap items-center gap-x-2">
					<InputNumberField
						value={minimumBuyableNumPerTarget?.value ?? undefined}
						handleInput={onSetMinimumBuyableNumPerTarget}
						errorMessage={minimumBuyableNumPerTarget?.error}
						hiddenSpinButton={false}
					/>
					<p>個以上から提供可能</p>
				</div>
			}
		/>
	);
};

QuestionOptionMinimumBuyableNumPerTarget.displayName = "QuestionOptionMinimumBuyableNumPerTarget";
